import { connect } from 'react-redux'
import {changeLabel,fetchFullConfig} from '../actions'
import Poster from '../components/Poster'

const mapStateToProps = (state) => {
    return state;
}

const mapDispatchToProps = (dispatch) => {
    return {
        onChangeLabel: (key,value) => {
            dispatch(changeLabel(key,value));
        },
        onFetchFullConfig:(orderId,posterId)=>{
            dispatch(fetchFullConfig(orderId,posterId))
        }
    }
}

const RxPoster = connect(
    mapStateToProps,
    mapDispatchToProps
)(Poster)

export default RxPoster


// WEBPACK FOOTER //
// ./src/containers/RxPoster.js